import { render, staticRenderFns } from "./v_channels_areas.vue?vue&type=template&id=699a138a&scoped=true&"
import script from "./v_channels_areas.vue?vue&type=script&lang=js&"
export * from "./v_channels_areas.vue?vue&type=script&lang=js&"
import style0 from "./v_channels_areas.vue?vue&type=style&index=0&id=699a138a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699a138a",
  null
  
)

export default component.exports